import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import {
	ColumnFields,
	CustomerDTO,
	Quote,
	RestService,
	TITLE_CASE,
	DIFFERENCE_FROM_NOW,
	TO_DOLLARS,
} from 'cargo-chief-commons';
import { SharedService } from '@service/shared/shared.service';
import { APP_ENV } from '@domain/constants/app-variables';
import { environment } from '@environment/environment';
import { UtilService } from '@service/util/util.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-load-detail',
	templateUrl: './load-detail.component.html',
	styleUrls: ['./load-detail.component.scss'],
	providers: [CurrencyPipe],
	encapsulation: ViewEncapsulation.None,
})
export class LoadDetailComponent implements OnInit {
	@Input() quote: Quote = null;
	@Input() isEditQuote: boolean = false;
	@Input() customer: CustomerDTO = null;
	@Output() quoteUpdated = new EventEmitter<Quote>();
	detailsView: Array<Array<ColumnFields>> = [];
	rerunRequestSent: boolean = false;

	LOAD_URL = null;
	SHOW_LOAD_URL = false;
	TITLE_CASE = TITLE_CASE;
	isLoading = false;
	DIFFERENCE_FROM_NOW = DIFFERENCE_FROM_NOW;
	TO_DOLLARS = TO_DOLLARS;

	constructor(
		public utilService: UtilService,
		public accountSettings: AccountSettingsService,
		private sharedService: SharedService,
		private urlService: UrlService,
		private restService: RestService
	) {}

	ngOnInit() {
		if (
			!this.utilService.isNullOrUndefined(localStorage.getItem('loadURL')) &&
			environment.environment != APP_ENV.PROD
		) {
			this.LOAD_URL = localStorage.getItem('loadURL');
			if (!this.utilService.isNullOrUndefined(this.LOAD_URL) && this.LOAD_URL != 'null') {
				this.SHOW_LOAD_URL = true;
			}
		}
	}

	ngOnChanges() {
		if (!this.utilService.isNullOrUndefined(this.quote)) {
			this.buildView();
		}
	}

	buildView() {
		this.detailsView = [];
		const details = this.sharedService.getQuoteDetailsView(this.quote);
		this.detailsView = details
			.map((x, i) => i % 2 == 0 && details.slice(i, i + 2))
			.filter((x) => x);
	}

	rerunLoad() {
		this.isLoading = true;
		const url = this.urlService.rerunBookingAssistant(this.quote.loadId);
		this.restService.POST(url, {}).subscribe({
			next: () => {
				this.utilService.showSnackbar(
					'This load will be re run now',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.rerunRequestSent = true;
			},
			complete: () => {
				this.isLoading = false;
			},
		});
	}
}
